import { IStoreState } from "@montana/store/store";
import { INotificationContainerState } from "@montana/containers/notification/notification";

import { generateContainer, IContainerProps } from "@montana/containers/base/generate-container";

import { pushNotification, removeNotification } from "./notification.actions";

const mapState = (state: IStoreState): INotificationContainerState => state.notification || {};

const actions = {
    pushNotification,
    removeNotification,
};

export type INotificationContainerProps = IContainerProps<ReturnType<typeof mapState>, typeof actions>;

export const [NotificationContainer, connectWithNotification, useNotification] = generateContainer(mapState, actions);
